import React, { useContext } from "react";
import { ResultsMenuCategory } from "@data-types/results";
import {
	ResultsMenuCategoryContext,
	ResultsMenuStoreContext,
} from "@state/context/results";
import ResultsCategoryItem from "./ResultsCategoryItem";

export default function ResultsCategoryList() {
	const store = useContext(ResultsMenuStoreContext);

	if (!store.selectedSportObj) return null;

	return (
		<>
			{store.selectedSportObj.children.map(
				(category: ResultsMenuCategory) => (
					<ResultsMenuCategoryContext.Provider
						key={category.id}
						value={category}
					>
						<ResultsCategoryItem />
					</ResultsMenuCategoryContext.Provider>
				)
			)}
		</>
	);
}
